module.exports = __webpack_public_path__ + "static/media/illustration-404.0f27d2de.png";